<template>
  <div id="app">
    <component :is="layout">
      <transition name="fade" mode="out-in" appear>
        <router-view />
      </transition>
    </component>
  </div>
</template>

<script>
const default_layout = "default";

export default {
  computed: {
    layout() {
      return (this.$route.meta.layout || default_layout) + "-layout";
    }
  }
};
</script>


<style lang="scss">
@import "./styles/main.scss";
@import "./styles/player.scss";

#app {
  width: 100vw;
  min-height: 100vh;
}

.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.3s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
</style>
